import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import InnerLayout from "../innerLayout/InnerLayout";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import { Button } from "../../components/Button";
import "./TvGuide.css";
import Select, { MultiValue, SingleValue } from "react-select";
import { Guid } from "../../../api/baseApi";
import { getBaseChannels } from "../../../api/channelsApi";
import { formatDate, getPastDateByDaysAgo } from "../../../services/dateService";
import { PlayerModel, getPlayers } from "../../../api/playersApi";
import { DayModeTvGuidePlayer, PlayerTvGuideRow, TvGuideCell, downloadTvGuidePdf, getDayModeTvGuide, getPlayerTvGuide } from "../../../api/tvGuideApi";
import tvGuidebanner from '../../images/tv-guide.jpg'
import { createPathWithId, Routes } from "../../../constants/routes";
import fileDownload from "js-file-download";
import { getPriorityListPlayers } from "../../../api/priorityListApi";


interface TvGuideProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string}
type TvGuideMode = "player" | "day"
type TvGuideRow = PlayerTvGuideRow | DayModeTvGuidePlayer
type PlayerGroup = { label: string, options: Option<Guid>[] }
type TvGuideFilters = {
    mode: TvGuideMode,
    playerMode: { channelId: Guid, playerId: Guid, startDate: string, endDate: string },
    dayMode: { playerIds: Guid[], date: string }
}

const tvGuideFiltersKey = "tvGuideFilters";

const getTvGuideFilters = () => {
    const defaultFilters: TvGuideFilters = {
        mode: "player",
        playerMode: {
            channelId: '',
            playerId: '',
            startDate: getPastDateByDaysAgo(0),
            endDate: getPastDateByDaysAgo(-7)
        },
        dayMode: {
            playerIds: [],
            date: getPastDateByDaysAgo(0)
        }
    };
    let filters = defaultFilters;
    const storedFilters = localStorage.getItem(tvGuideFiltersKey);
    if(storedFilters){
        try {
            const parsedFilters = JSON.parse(storedFilters) as Partial<TvGuideFilters>;
            filters = {
                mode: parsedFilters.mode || defaultFilters.mode,
                playerMode: {...defaultFilters.playerMode, ...parsedFilters.playerMode},
                dayMode: {...defaultFilters.dayMode, ...parsedFilters.dayMode}
            };
        } catch {
        }
    }

    return filters;
}

const TvGuide: FunctionComponent<TvGuideProps> = (props : TvGuideProps) => {
    let {history} = props;
    const [storedFilters] = useState(getTvGuideFilters);

    let [isLoading, setIsloading] = useState(false);
    let [tvGuideMode, setTvGuideMode] = useState<TvGuideMode>(storedFilters.mode);
    let [channels, setChannels ] = useState<Option<Guid>[]>([]);
    let [selectedChannel, setSelectedChannel] = useState<Guid>(storedFilters.playerMode.channelId);
    let [selectedStartDate, setSelectedStartDate] = useState<string>(storedFilters.playerMode.startDate);
    let [selectedEndDate, setSelectedEndDate] = useState<string>(storedFilters.playerMode.endDate);
    let [selectedDayDate, setSelectedDayDate] = useState<string>(storedFilters.dayMode.date);

    let [players, setPlayers ] = useState<PlayerModel[]>([]);
    let [filteredPlayers, setFilteredPlayers ] = useState<Option<Guid>[]>([]);
    let [playerGroups, setPlayerGroups] = useState<PlayerGroup[]>([]);
    let [selectedPlayer, setSelectedPlayer] = useState<Guid>(storedFilters.playerMode.playerId);
    let [selectedPlayers, setSelectedPlayers] = useState<Guid[]>(storedFilters.dayMode.playerIds);

    let [tvGuide, setTvGuide] = useState<TvGuideRow[]>([]);

    useEffect(()=>{
        async function fetchData() {
            setIsloading(true);
            await Promise.all([updateChannelsList(),updatePlayersList(),updatePlayerGroups()])
            setIsloading(false);
        };
        
        fetchData()
    },[])

    useEffect(()=>{
        if(selectedChannel){
            filterPlayersByChannelId(players, selectedChannel)
        } else {
            setSelectedPlayer('')
        }
    },[selectedChannel,players])

    useEffect(()=>{
        const filters: TvGuideFilters = {
            mode: tvGuideMode,
            playerMode: {
                channelId: selectedChannel,
                playerId: selectedPlayer,
                startDate: selectedStartDate,
                endDate: selectedEndDate
            },
            dayMode: {
                playerIds: selectedPlayers,
                date: selectedDayDate
            }
        };
        localStorage.setItem(tvGuideFiltersKey, JSON.stringify(filters));
    },[tvGuideMode,selectedChannel,selectedPlayer,selectedStartDate,selectedEndDate,selectedPlayers,selectedDayDate])

    useEffect(()=>{
        async function fetchData() {
            setIsloading(true);
            await updateTvGuide();
            setIsloading(false);
        };
        
        if((tvGuideMode === "player" && selectedPlayer && selectedStartDate && selectedEndDate)
            || (tvGuideMode === "day" && selectedPlayers.length && selectedDayDate)){
            fetchData()
        } else {
            setTvGuide([])
        }
    },[tvGuideMode,selectedPlayer,selectedPlayers,selectedStartDate,selectedEndDate,selectedDayDate])

    const updateChannelsList = async () => {
        let result = await getBaseChannels();
        if(result.type === "succes"){
            setChannels(result.data.items.map(it => {return {value: it.id, label: it.name}}));
        }
    }

    const updatePlayersList = async () => {
        const res = await getPlayers();
        setPlayers(res.players)
    }

    const updatePlayerGroups = async () => {
        let result = await getPriorityListPlayers();
        if(result.type === "succes"){
            setPlayerGroups(result.data.items
                .filter(it => it.players.length)
                .map(it => {return {label: it.name, options: it.players.map(player => {return {value: player.id, label: player.name}})}}));
        }
    }

    const updateTvGuide = async () => {
        if(tvGuideMode === "day"){
            let result = await getDayModeTvGuide(selectedPlayers, selectedDayDate);
            if(result.type === "succes"){
                setTvGuide(result.data.data.players)
            }
            return;
        }

        let result = await getPlayerTvGuide(selectedPlayer, selectedStartDate, selectedEndDate);
        if(result.type === "succes"){
            setTvGuide(result.data.data.dates)
        }
    }


    const filterPlayersByChannelId = (players: PlayerModel[], channelId: Guid) => {
        const filteredPlayers = players.filter( it => it.channel?.id === channelId)
        setFilteredPlayers(filteredPlayers.map(it => {return {value: it.id, label: it.name}}));
    }

    const onChangeSelectedChannel = (value: SingleValue<Option<Guid>>) => {
        setSelectedPlayer('');
        if(value){
            setSelectedChannel(value.value);
        } else {
            setSelectedChannel('');
        }
    }

    const onChangeSelectedPlayer = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setSelectedPlayer(value.value);
        } else {
            setSelectedPlayer('');
        }
    }

    const onChangeSelectedPlayers = (values: MultiValue<Option<Guid>>) => {
        setSelectedPlayers(values.map(it => it.value));
    }

    const togglePlayerGroup = (group: PlayerGroup) => {
        const playerIds = group.options.map(it => it.value);
        const isSelected = playerIds.every(it => selectedPlayers.includes(it));
        if(isSelected){
            setSelectedPlayers(selectedPlayers.filter(it => !playerIds.includes(it)));
        } else {
            setSelectedPlayers(Array.from(new Set(selectedPlayers.concat(playerIds))));
        }
    }

    const renderPlayerGroup = (group: PlayerGroup) => {
        const isSelected = group.options.every(it => selectedPlayers.includes(it.value));
        const onMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
            event.preventDefault();
            event.stopPropagation();
            togglePlayerGroup(group);
        }
        const result = <div className="tv-guide-player-group" onMouseDown={onMouseDown}>
            <input type="checkbox" checked={isSelected} readOnly />
            <span>{group.label}</span>
        </div>;

        return result;
    }

    const onStartDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedStartDate(event.target.value);
    const onEndDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedEndDate(event.target.value); 
    const onDayDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedDayDate(event.target.value);

    const downloadPdf = async () => {
        setIsloading(true);

        try {
            const result = await downloadTvGuidePdf(selectedPlayer, selectedStartDate, selectedEndDate);
            fileDownload(result.data, result.filename);
        } finally {
            setIsloading(false);
        }
    }

    const convertTimeToMinutes = (time:string) => {
        const [hours, minutes, seconds] = time.split(':').map(Number);
        return hours * 60 + minutes + seconds / 60;
    };

    const calculateEventTime = (startTime:string, endTime:string, intervalMinutes:number) => {
        const startMinutes = convertTimeToMinutes(startTime);
        const endMinutes = convertTimeToMinutes(endTime);
    
        const startOffset = startMinutes % intervalMinutes;

        const offsetPercentage = (startOffset / intervalMinutes * 100).toFixed(2);
    
        const startInterval = Math.floor(startMinutes / intervalMinutes) + 1;

        const eventDurationPercentage = ((endMinutes - startMinutes) / intervalMinutes * 100).toFixed(2)

        return {
            startInterval,
            offsetPercentage,
            eventDurationPercentage
        };
    }

    const renderTvGuide = (tvGuideRows: TvGuideRow[]) => {
        return tvGuideRows.map( it => {
            const rowName = "date" in it ? formatDate(it.date) : it.playerName;
            return <div key={`${rowName}-row`} className="tv-guide-program">
                <div className="program-date">{rowName}</div>
                {renderTvGuideCells(it.spans)}
            </div>
        })
    }

    const goToStream = (listId: Guid | null, streamId: Guid | null) => {
        const data = streamId
        if(listId && streamId){
            history.push(createPathWithId(Routes.PriorityList, listId), data)
        }
    }

    const renderTvGuideCells = (cells: TvGuideCell[]) => {
        return cells.map( it => {
            let {startInterval, offsetPercentage, eventDurationPercentage} = calculateEventTime(it.start, it.end, 30)
            return  <div key={it.start+it.end} className="tv-guide-cell" style={{
                            ['--column-start']:`${startInterval + 1}`,
                            ['--left']:`${offsetPercentage}%`,
                            ['--width']:`${eventDurationPercentage}%`,
                        }as React.CSSProperties}>
                        <div className="program-info">
                            <p className="program-title" onClick={() => {goToStream(it.scheduledStreamListId, it.streamId)}}>{it.title}</p>
                            <p className="program-time">{it.start.slice(0, -3)} - {it.end.slice(0, -3)}</p>
                        </div>
                    </div>
        })
    }

    const renderTimeline = (withPseudoLines: boolean = false) => {
        const timelineElements = [];

        if(!withPseudoLines){
            for(let i = 0; i < 24; i++){
                timelineElements.push(
                    <>
                        <div key={`hour-${i}`} className="timeline-slot">{i.toString().padStart(2, '0')}:00</div>
                        <div key={`half-hour-${i}`} className="timeline-slot">{i.toString().padStart(2, '0')}:30</div>
                    </>
                );
            }
    
            return timelineElements;
        } else {
            for(let i = 0; i < 24; i++){
                timelineElements.push(
                    <>
                        <div key={`hourP-${i}`} className="timeline-pseudo-slot"></div>
                        <div key={`half-hourP-${i}`} className="timeline-pseudo-slot"></div>
                    </>
                );
            }
    
            return timelineElements;
        }
    }

    
    return (  
        <InnerLayout 
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="tvGuide">
                <>
                    <div className="tv-guide-mode-switch-wrapper">
                        <div className="tv-guide-mode-switch" role="group" aria-label="TV Guide mode">
                            <Button
                                color={tvGuideMode === "player" ? "green" : "gray"}
                                label="Player Mode"
                                onClick={() => setTvGuideMode("player")}/>
                            <Button
                                color={tvGuideMode === "day" ? "green" : "gray"}
                                label="Day Mode"
                                onClick={() => setTvGuideMode("day")}/>
                        </div>
                    </div>

                    <div className="timeline-settings mb-30">
                        <div className="tv-guide-banner-block">
                            <img src={tvGuidebanner} alt="" className="tv-guide-banner" />
                        </div>
                        {tvGuideMode === "player" ? <>
                            <div className="timeline-settings-elem transformY5">
                                <label>Networks</label>
                                <Select
                                    options={channels}
                                    classNamePrefix={`select`}
                                    onChange={onChangeSelectedChannel}
                                    isClearable={true}
                                />
                            </div>
                            <div className="timeline-settings-elem transformY5">
                                {selectedChannel && <>
                                    <label>Player</label>
                                    <Select
                                        options={filteredPlayers}
                                        classNamePrefix={`select`}
                                        onChange={onChangeSelectedPlayer}
                                        isClearable={true}
                                        value={filteredPlayers.find(it => it.value === selectedPlayer)}/>
                                </>}
                            </div>
                            <div className="timeline-settings-elem">
                                <label>Start</label>
                                <input className="form-control" type="date" onChange={onStartDateChanged} value={selectedStartDate} ></input>
                            </div>
                            <div className="timeline-settings-elem">
                                <label>End</label>
                                <input className="form-control" type="date" onChange={onEndDateChanged} value={selectedEndDate}></input>
                            </div>
                        </> : <>
                            <div className="timeline-settings-elem tv-guide-day-players transformY5">
                                <label>Players</label>
                                <Select
                                    options={playerGroups}
                                    classNamePrefix={`select`}
                                    onChange={onChangeSelectedPlayers}
                                    formatGroupLabel={renderPlayerGroup}
                                    isClearable={true}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    value={playerGroups.flatMap(it => it.options).filter(it => selectedPlayers.includes(it.value))}/>
                            </div>
                            <div className="timeline-settings-elem">
                                <label>Date</label>
                                <input className="form-control" type="date" onChange={onDayDateChanged} value={selectedDayDate} ></input>
                            </div>
                        </>}
                    </div>

                    { tvGuide.length ? <>
                    <div className={`tv-guide-wrapper ${tvGuideMode === "player" ? "tv-guide-wrapper-player-mode" : ""}`}>
                        <div className="tv-guide-block">
                            <div className="timeline">
                                <div className=""></div>
                                {renderTimeline()}
                            </div>
                            <div className="timeline-pseudo">
                                <div className="timeline-pseudo-slot"></div>
                                {renderTimeline(true)}
                            </div>
                            {renderTvGuide(tvGuide)}
                        </div>
                    </div></> : <p>{tvGuideMode === "player" ? "Please select Network, Player and Dates" : "Please select Players and Date"}</p>}

                    <div className="tv-guide-text-block">
                        <p>© Copyright C-Screens 2024 | <a target="_blank" href="https://c-screens.com/">www.c-screens.com</a> | <a href="mailto:prize@c-screens.com">prize@c-screens.com</a> </p>
                        <p>TV Guide Viewing Disclaimer</p>

                        <ol>
                            <li>The TV guide provided is subject to change without prior notice.</li>
                            <li>Adverse weather conditions may have a significant affect on the scheduling and broadcasting of summer sporting events.</li>
                            <li>Changes may occur at the discretion of the landowner and CScreens LTD.</li>
                            <li>We strive to provide accurate and up-to-date information but cannot guarantee the timeliness or accuracy of the content.</li>
                            <li>Users are encouraged to verify scheduling information with the respective TV channels.</li>
                            <li>By using this TV guide, users agree to acknowledge and accept the possibility of changes.</li>
                        </ol>
                    </div>

                    {tvGuideMode === "player" && tvGuide.length ? <div className="d-flex justify-content-end mb-20">
                        <a href="#download-pdf" onClick={event => { event.preventDefault(); downloadPdf(); }}>Download PDF</a>
                    </div> : <></>}
                    <GlobalSpinner isShow={isLoading} />
                </>
               
        </InnerLayout> );
}

export default withRouter(TvGuide)
